const About = () => {
  return(
    <div style={{margin:"300px"}}>
      <h1>About</h1>
      <h3>work in progress</h3>
    </div>
  );
};

export default About;